/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import SectionContainer from 'stories/V1/layouts/SectionContainer'

const ManifestoContainer = styled.div`
    max-width: 1024px;
    padding: 48px;
    position: relative;
    border-radius: 24px;
    background: ${theme.colors.backgroundTransparent};
    z-index: 1;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 24px;
        padding: 4px;
        background: linear-gradient(103.57deg, #9a76cf 0%, #797fdd 25%, #008de8 50%, #0095a8 75%, #9a76cf 100%);
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        z-index: -1;
    }
    @media (max-width: 750px) {
        padding: 24px;
    }
`

const ManifestoGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 10px;
    row-gap: 30px;
    width: 100%;
    align-items: start;

    @media (max-width: 750px) {
        grid-template-columns: 1fr;
    }
`

const ManifestoText = styled.div`
    font-family: var(--font-inter);
    font-size: 23px;
    font-weight: 550;
    line-height: 32px;
    letter-spacing: -0.2px;
    color: #f9f9f9;

    @media (max-width: 750px) {
        font-size: 17px;
        line-height: 24px;
        letter-spacing: 0.3px;
    }
`

const CareersManifesto = () => {
    const manifestoItems = [
        {
            number: 1,
            text: `Education is at a historic inflection point. AI is rapidly transforming how students learn, finally enabling truly personalised education for all on a global scale. Not just disrupting traditional learning, but revolutionising the entire global tutoring market.`,
        },
        {
            number: 2,
            text: `Born from our founders' own problems and frustrations in high school and driven by a mission to democratise education globally, Knowunity stands at the forefront of this revolution. Millions of students already engage with our AI study companion daily. With a rapidly growing user base across multiple countries, proprietary learning data, and $30M in fresh funding, we're positioned to become the definitive AI learning platform.`,
        },
        {
            number: 3,
            text: `The race to the top in this newly emerging AI learning market is intense, with well-funded competitors emerging globally, but we believe only one companion will emerge as No 1, helping hundreds of millions of students with truly personalised education.`,
        },
        {
            number: 4,
            text: `We've secured one of Europe's largest education funding rounds in recent years because investors recognise our potential to dominate this emerging AI learning market. The window to establish market leadership is measured in months, not years, and we're building an elite team of talent who can execute at unprecedented speed and are driven to make their mark in building a generational company in AI learning.`,
        },
    ]

    return (
        <SectionContainer
            title={'Knowunity 2.0 Manifesto'}
            backgroundColor={
                'linear-gradient(103.57deg, #221140 0%, #14183A 25%, #061C31 50%, #051E22 75%, #221140 100%), linear-gradient(0deg, #1A1A1A, #1A1A1A);'
            }
            borderRadius="48px"
            mobileBorderRadius="32px"
        >
            <ManifestoContainer>
                <ManifestoGrid>
                    {manifestoItems.map((item, index) => (
                        <React.Fragment key={index}>
                            <ManifestoText>{item.text}</ManifestoText>
                        </React.Fragment>
                    ))}
                </ManifestoGrid>
            </ManifestoContainer>
        </SectionContainer>
    )
}

export default CareersManifesto
